export enum Permissions {
  INICIO = 'INICIO',
  COBRAR = 'COBRAR',
  TRANSFERENCIA = 'TRANSFERENCIA',
  MOVIMIENTO = 'MOVIMIENTO',
  MI_COMERCIO = 'MI_COMERCIO',
  PAGAR = 'PAGAR'
}
